import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { StorageConfiguration } from '@ragu-components/ord-types';

const StorageConfigurationsList = React.lazy(async () => import('./StorageConfigurationsList'));

export const storageConfigurationsResource: OrdResourceProps = {
  key: Resources.storage_configurations,
  name: Resources.storage_configurations,
  list: <StorageConfigurationsList />,
  options: {},
  recordRepresentation: (record: StorageConfiguration): string => record.name,
};
